import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../hooks/reduxHooks";
import PageLoader from "../../components/common/loader/pageLoader";
import PersonalJournalComponent from "../../components/personal-journal/PersonalJournalComponent";
import { getPersonalJournalApi } from "../../services/personalJournal.service";
interface PersonalJournalContainerInterface {}

interface SkincareProduct {
  product_id: number;
  [key: string]: any;
}

interface SkincareTrackerData {
  skincare_data: SkincareProduct[];
  [key: string]: any;
}
const PersonalJournalContainer = () => {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<SkincareTrackerData | undefined>();
  const profile = useAppSelector((state) => state?.profile);
  const { survey_id } = profile;
  useEffect(() => {
    setLoading(true);
    if (survey_id) {
      fetchPersonalJournalData();
    }
  }, [survey_id]);

  const fetchPersonalJournalData = () => {
    dispatch(
      getPersonalJournalApi({
        survey_id: survey_id,
        finalCallback: () => {
          setLoading(false);
        },
        successCallback: (data?: any) => {
          setData(data);
        },
        unAunthenticatedCallback: () => {
          // handle unauthenticated case here if needed
        },
      })
    );
  };

  // const savePersonalJournalData = (
  //   productId: number,
  //   field: string,
  //   value: any
  // ) => {
  //   setData((prevData: SkincareTrackerData | undefined) => {
  //     if (!prevData || !prevData.skincare_data) return prevData;

  //     const updatedSkincareData = prevData.skincare_data.map(
  //       (product: SkincareProduct) => {
  //         if (product.product_id === productId) {
  //           let updatedValue = value;

  //           // Handle date formatting for API
  //           if (field === "start_date" || field === "expire_date") {
  //             updatedValue = value ? dayjs(value).format("YYYY-MM-DD") : null;
  //           }

  //           return { ...product, [field]: updatedValue };
  //         }
  //         return product;
  //       }
  //     );

  //     return {
  //       ...prevData,
  //       skincare_data: updatedSkincareData,
  //     };
  //   });
  // };

  if (loading) {
    return <PageLoader />;
  }

  return <PersonalJournalComponent data={data} />;
};

export default PersonalJournalContainer;
